import React from 'react';
import { PermissionGuardProps } from '../../types';
import { usePermissionCheck } from '../../hooks/usePermissions';

export const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
  permissions, 
  fallback = null, 
  children 
}) => {
  const hasPermission = usePermissionCheck(permissions);
  
  return hasPermission ? <>{children}</> : <>{fallback}</>;
};